import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { CircularProgress } from '@material-ui/core'
import { useLocation } from 'react-router-dom'

const UploadViewer = (props) => {
  const location = useLocation()
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(null)
  const [upload, setUpload] = React.useState(null)
  const [blobUrl, setBlobUrl] = React.useState(null)

  React.useEffect(() => {
    const fetchFile = async () => {
      try {
        // Get URL from query parameters
        const params = new URLSearchParams(location.search)
        const fileUrl = params.get('url')
        const fileName = params.get('name') || 'file'
        const fileType = params.get('type') || 'application/octet-stream'

        if (!fileUrl) {
          setError('No file URL provided')
          setLoading(false)
          return
        }

        setUpload({ url: fileUrl, name: fileName, type: fileType })

        // Fetch the file as blob to bypass Content-Disposition headers
        let cleanURL = fileUrl
        if (!cleanURL.includes('https')) {
          cleanURL = `https://${cleanURL}`
        }

        const fileResponse = await axios.get(cleanURL, {
          withCredentials: false,
          headers: {
            'Content-Type': 'application/octet-stream',
            'Accept': 'application/pdf, application/octet-stream, image/*'
          },
          responseType: 'blob'
        })

        // Create blob URL
        const fileBlob = new Blob([fileResponse.data], {
          type: fileType
        })
        const url = window.URL.createObjectURL(fileBlob)
        setBlobUrl(url)
        setLoading(false)
      } catch (err) {
        console.error('Error fetching file:', err)
        setError('Failed to load file')
        setLoading(false)
      }
    }

    fetchFile()

    // Cleanup blob URL on unmount
    return () => {
      if (blobUrl) {
        window.URL.revokeObjectURL(blobUrl)
      }
    }
  }, [location.search])

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#333'
      }}>
        <CircularProgress style={{ color: 'white' }} />
      </div>
    )
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#333',
        color: 'white',
        fontSize: '20px'
      }}>
        {error}
      </div>
    )
  }

  const isPDF = upload?.type?.toLowerCase().includes('pdf')
  const isImage = upload?.type?.includes('image')
  const isOfficeDoc = upload?.type?.includes('officedocument')

  return (
    <div style={{
      margin: 0,
      padding: 0,
      width: '100vw',
      height: '100vh',
      overflow: 'hidden',
      background: '#333'
    }}>
      {isPDF && (
        <object
          data={blobUrl}
          type="application/pdf"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        >
          <embed src={blobUrl} type="application/pdf" width="100%" height="100%" />
        </object>
      )}

      {isImage && (
        <img
          src={blobUrl}
          alt={upload.name}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            display: 'block',
            margin: 'auto',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            objectFit: 'contain'
          }}
        />
      )}

      {isOfficeDoc && (
        <iframe
          src={`https://docs.google.com/gview?url=${upload.url}&embedded=true`}
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    url: state.url,
    user: state.user
  }
}

export default connect(mapStateToProps)(UploadViewer)
